import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './views/index';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './utils/store'
import moment from 'moment'

window.moment = moment

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
